import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { TableConfig } from 'app/shared/util/table-config.utils';

import { ToolHistoryService } from 'app/core/services/tool-history.service';
import { ToolStatusHistory } from 'app/shared/models/tool-status-history.model';

import * as FileSaver from 'file-saver';
import { Log } from "ng2-logger";
import * as _ from "lodash";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';
import { ObservableService } from '@app/core/services/observable.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-status-history',
    templateUrl: './status-history.component.html',
    styleUrls: ['./status-history.component.scss']
})
export class StatusHistoryComponent implements OnInit, OnDestroy {
    _logger = Log.create(StatusHistoryComponent.name);
    toolStatusHistory: ToolStatusHistory[] = [];
    tableConfig = new TableConfig();

    requestConfig = new TableConfig();

    tableFilters = [];
    reportFilters = [];

    isLoadingToolStatusHistory = false;
    isLoadingDownload: boolean;
    observableSubscription: Subscription;

    constructor(private toolHistoryService: ToolHistoryService,
                private toastr: ToastsManager,
                private translationService: TranslateService,
                observableService: ObservableService) {
        this.observableSubscription = observableService.hasChanged$.subscribe(
            () => {
                this.getToolStatusHistory(this.tableConfig);
            }
        )
    }

    ngOnInit() {
        this.tableConfig.sorter = {
            field: 'date',
            IsSortingAscending: false
        };
        this.getToolStatusHistory(this.tableConfig);
    }

    ngOnDestroy() {
        this.observableSubscription.unsubscribe();
    }

    onFilterChange(tableFilters: any = [], reportFilters: any = []) {
        this.tableFilters = tableFilters;
        this.reportFilters = reportFilters;

        const requestConfig = Object.assign({}, this.tableConfig);
        requestConfig.filters = requestConfig.filters.concat(this.reportFilters);

        this.requestConfig = requestConfig;

        this.getToolStatusHistory(requestConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.getToolStatusHistory(tableConfig);
    }

    getToolStatusHistory(tableConfig = this.tableConfig) {
        this._logger.info('getToolStatusHistory:: Retrieving list of tools status history', tableConfig);
        this.isLoadingToolStatusHistory = true;
        this.toolHistoryService.getStatusHistory(tableConfig).subscribe(data => {
                this._logger.info('getToolStatusHistory:: API returned data', data);
                this.toolStatusHistory = data.toolStatusHistory;
                this.tableConfig.pager.count = data.count;
                this.isLoadingToolStatusHistory = false;
            },
            (error: any) => {
                this.isLoadingToolStatusHistory = false;
                this._logger.info('getToolStatusHistory:: API returned error', error);
            });
    }

    onStatusHistoryDownload(tableConfig = this.tableConfig) {
        this.isLoadingDownload = true;
        this.toolHistoryService.downloadStatusHistoryReport(tableConfig).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    const blob = new Blob([data.body], {type: 'application/xsls'});
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
                this.isLoadingDownload = false;
            },
            (error: any) => {
                this.isLoadingDownload = false;
                this.toastr.error(this.translationService.instant('Server_Error'));
            });
    }

    onPageChange(tableConfig: TableConfig) {
        this.tableFilters = tableConfig.filters;
        tableConfig.filters = _.union(this.reportFilters, this.tableFilters);
        this.getToolStatusHistory(tableConfig);
    }
}
